import React from 'react';
import cx from 'classnames';
import { Container, Row, Col, Form } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { animateScroll as scroll } from 'react-scroll';

import spotmentorLogo from '../Header/img/logowhite.png';
import UpArrows from './icons/UpArrows';
import LinkedIn from './icons/LinkedIn';
import Envelope from './icons/Envelope';
import Phone from './icons/Phone';
import { smoothScroll } from '../../utils';
import s from './Footer.css';
import history from '../../history';

class Footer extends React.Component {
  scrollToNews = () => {
    if (window.location.pathname === '/') {
      smoothScroll.scrollTo('newsHere');
    } else {
      history.push(`/#newsHere`);
    }
  };

  scrollTop = () => {
    scroll.scrollToTop();
    // smoothScroll.scrollTo('top');
  };

  render() {
    const {
      contactFields,
      changeFields,
      submitContactUs,
      isSendingMsg,
    } = this.props;

    return (
      <div id="footer">
        <footer
          className={cx(s.row, s.footerArea, s.footerAreaTwo, s.footerAreaFour)}
        >
          <div className={s.footerTop}>
            <Container>
              <Row>
                <Col md="4" xs="12" className={cx(s.widget, s.singleFtWidget)}>
                  <a href="http://www.spotmentor.com" className={s.brandLogo}>
                    <img src={spotmentorLogo} alt="logo" />
                  </a>
                  <ul>
                    <li>
                      <i className="fa fa-map-marker" />
                      <div className={cx(s.locationAddress, s.fleft)}>
                        GVT, Sector 43, Gurgaon
                      </div>
                    </li>
                    <li>
                      <i className="fa fa-envelope" aria-hidden="true" />
                      <div className={cx(s.locationAddress, s.fleft)}>
                        shekhar.suman@in.ey.com
                      </div>
                    </li>
                    <li>
                      <i className="fa fa-phone" />
                      <div className={cx(s.locationAddress, s.fleft)}>
                        +91 7738257059
                      </div>
                    </li>
                  </ul>
                  <svg
                    className="icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="100"
                    height="100"
                    viewBox="0 0 65 26"
                  >
                    <g fill="#5C7285" fillRule="evenodd">
                      <path
                        fillRule="nonzero"
                        d="M19.977 6.819l-.001-.02c-.01-.24-.017-.493-.021-.775-.02-1.376-1.049-2.514-2.344-2.59-2.7-.16-4.79-1.096-6.574-2.945l-.015-.015a1.439 1.439 0 0 0-2.043 0l-.015.015C7.179 2.338 5.09 3.273 2.389 3.433 1.094 3.51.065 4.648.046 6.024c-.004.28-.011.534-.021.775l-.002.045c-.052 2.926-.117 6.566 1.03 9.87.63 1.818 1.584 3.398 2.837 4.696 1.426 1.479 3.294 2.653 5.552 3.49A1.638 1.638 0 0 0 10 25a1.591 1.591 0 0 0 .56-.101c2.254-.838 4.12-2.013 5.546-3.491 1.252-1.299 2.206-2.879 2.837-4.697 1.15-3.314 1.086-6.962 1.034-9.892zm-2.327 9.386c-1.209 3.483-3.677 5.875-7.546 7.312a.292.292 0 0 1-.208 0c-3.872-1.435-6.342-3.825-7.55-7.308-1.057-3.046-.997-6.388-.945-9.337v-.016c.012-.253.019-.519.023-.81.008-.611.466-1.117 1.042-1.15 1.528-.091 2.87-.405 4.104-.96 1.232-.554 2.326-1.335 3.345-2.387a.122.122 0 0 1 .17 0c1.02 1.052 2.113 1.833 3.345 2.387 1.233.555 2.576.869 4.104.96.576.033 1.034.539 1.043 1.15.004.293.011.558.022.81.052 2.952.11 6.296-.949 9.349z"
                      />
                      <path
                        fillRule="nonzero"
                        d="M10 6.307c-3.228 0-5.853 2.79-5.853 6.218 0 3.429 2.625 6.218 5.853 6.218 3.227 0 5.853-2.79 5.853-6.218 0-3.429-2.626-6.218-5.853-6.218zm0 10.972c-2.468 0-4.475-2.133-4.475-4.754C5.525 9.903 7.532 7.77 10 7.77c2.467 0 4.475 2.132 4.475 4.754 0 2.621-2.008 4.754-4.475 4.754z"
                      />
                      <path d="M11.682 10.594l-2.719 2.888-.737-.783a.66.66 0 0 0-.975 0 .765.765 0 0 0 0 1.035l1.225 1.301c.135.143.311.215.487.215a.667.667 0 0 0 .488-.215l3.206-3.406a.765.765 0 0 0 0-1.035.66.66 0 0 0-.975 0z" />
                      <text
                        fontFamily="GoogleSans-Bold, Google Sans"
                        fontSize="14"
                        fontWeight="bold"
                        transform="translate(0 -1)"
                      >
                        <tspan x="24" y="14">
                          GDPR
                        </tspan>
                      </text>
                      <text
                        fontFamily="GoogleSans-Regular, Google Sans"
                        fontSize="10"
                        letterSpacing="2.9"
                        transform="translate(0 -1)"
                      >
                        <tspan x="25" y="24">
                          Ready
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </Col>
                <Col md="4" xs="12" className={cx(s.widget, s.latestWidget)} />
                <Col
                  md="4"
                  xs="12"
                  className={cx(s.widget, s.contactFromWidget)}
                >
                  <h4 className={s.widgetTitle}>contact us</h4>
                  <div className={cx(s.widgetContactList, s.m0)}>
                    <Form className={cx(s.submitForm, s.m0)}>
                      <input
                        type="text"
                        className={s.formControl}
                        id="contactusname"
                        onChange={e => changeFields('name', e.target.value)}
                        placeholder="Your Name"
                        value={contactFields.name}
                      />
                      <input
                        type="email"
                        className={s.formControl}
                        id="contactusemail"
                        onChange={e => changeFields('email', e.target.value)}
                        placeholder="Your Email"
                        value={contactFields.email}
                      />
                      <input
                        type="text"
                        className={s.formControl}
                        id="contactusnumber"
                        onChange={e => changeFields('number', e.target.value)}
                        placeholder="Your Phone Number"
                        value={contactFields.number}
                        name="number"
                      />
                      <textarea
                        className={cx(s.formControl, s.message)}
                        id="contactusmessage"
                        onChange={e => changeFields('message', e.target.value)}
                        placeholder="Your Message"
                        value={contactFields.message}
                      />
                      <button
                        className={cx(s.submit, s.btnH)}
                        type="submit"
                        onClick={submitContactUs}
                      >
                        {isSendingMsg ? 'Sending..' : 'Send'}
                      </button>
                    </Form>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <div className={cx(s.m0, s.footerBottom)}>
            <Container>
              <div className={s.scrollT} onClick={this.scrollTop}>
                <UpArrows />
              </div>
              <Row>
                <Col
                  md="10"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <a href="/legal/cookie-policy" className={s.link}>
                    Cookie policy
                  </a>
                  <a href="/legal/gdpr-policy" className={s.link}>
                    GDPR policy
                  </a>
                  <div>
                    Copyright &copy; 2018 <br className={s.visibleXs} />{' '}
                    <a href="http://www.spotmentor.com">spotmentor.com</a>
                  </div>
                </Col>
                <Col md="2" className={s.right}>
                  <div className={s.svgSocialIcons}>
                    <a href="mailto: shekhar.suman1@in.ey.com">
                      <Envelope />
                    </a>
                  </div>
                  <div className={s.svgSocialIcons}>
                    <a href="phone: +917738257059">
                      <Phone />
                    </a>
                  </div>
                  <div className={s.svgSocialIcons}>
                    <a
                      href="https://www.linkedin.com/company/spotmentor-education-technologies/"
                      target="_blank"
                    >
                      <LinkedIn />
                    </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </footer>
      </div>
    );
  }
}

export default withStyles(s)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js